import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Cash(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Cash", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M29.8572 2.70233 2.70328 29.8563c-.60307.6031-.60307 1.5808 0 2.1839L15.9605 45.2974c.603.6031 1.5808.6031 2.1839 0l27.1539-27.154c.6031-.603.6031-1.5808 0-2.1839L32.0411 2.70233c-.603-.60306-1.5808-.60306-2.1839 0Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27.7987 9.48165 9.48067 27.7996c-.23042.2202-.38696.5064-.44807.8192-.06111.3128-.02379.6369.10682.9276.20527.4186.312.8786.312 1.3447 0 .4662-.10673.9262-.312 1.3448-.13067.2908-.16802.615-.10691.9279.06111.313.21767.5993.44816.8196l4.53523 4.5352c.2203.2305.5066.3871.8196.4482.3129.0611.6371.0238.9279-.1069.4186-.2053.8786-.312 1.3448-.312.4662 0 .9262.1067 1.3447.312.2907.1306.6148.1679.9276.1068.3128-.0611.599-.2176.8192-.4481l18.318-18.318c.2304-.2201.3869-.5063.448-.8191.0611-.3128.0238-.6369-.1068-.9276-.2053-.4186-.312-.8786-.312-1.3448 0-.4661.1067-.9261.312-1.3447.1307-.2908.168-.615.1069-.928-.0611-.3129-.2176-.5992-.4481-.8195l-4.5353-4.53525c-.2203-.23049-.5066-.38706-.8195-.44817-.313-.06111-.6371-.02376-.928.10692-.4185.20527-.8785.312-1.3447.312-.4662 0-.9262-.10673-1.3448-.312-.2907-.13061-.6148-.16793-.9276-.10682-.3128.06111-.5989.21764-.8191.44807Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24 30.75c3.7279 0 6.75-3.0221 6.75-6.75s-3.0221-6.75-6.75-6.75-6.75 3.0221-6.75 6.75 3.0221 6.75 6.75 6.75ZM31.5 18c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5Zm-15 15c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Cash.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Cash"
};
validateTidalLicense();
export {
  Cash
};
//# sourceMappingURL=Cash.js.map
